/** Brand mark. Its colours are tokens, so it reskins with everything else. */
export function Mark({ letter = "N" }: { letter?: string }) {
  return <div className="mark">{letter}</div>;
}
